module.exports = __webpack_public_path__ + "static/media/StatsHorizontal.f24bbe53.png";